import React from 'react';
import PageEnvelope from '../elements/PageEnvelope';
import { Server } from 'src/server/server';
import { NavLink, Navigate } from 'react-router-dom';
import Portrait from '../elements/Portrait';
import PageHeader from '../elements/PageHeader';
import { WithRouterProps } from '../util/withRouter';
import './SitePage.css';
import { BsSearch } from 'react-icons/bs';
import AlertModal from '../modals/AlertModal';

interface UsersPageProps {
  router: WithRouterProps;
}

interface UsersPageState {
  error: string;
  users: any[];
  loading: boolean;
  slug: string;
  mode: string;
  header: string;
  navigate: string;
  alert: string;
  search: string;
}

class UsersPage extends React.Component<UsersPageProps , UsersPageState> {
  constructor(props:UsersPageProps) {
    super(props);
    this.state = {
      error: '',
      users: [],
      loading: false,
      slug: '',
      mode: '',
      header: '',
      navigate: '',
      alert: '',
      search: ''
    }
  }

  componentDidMount(): void {
    if(Server.account.isLoggedIn())
      this.load();
    else
      this.setState({users: [], mode: 'members'})
  }

  componentDidUpdate(prevProps: Readonly<UsersPageProps>) {
    if(prevProps.router.location.pathname != this.props.router.location.pathname) 
      this.load();
  }

  async load() {
    let parts = window.location.pathname.split('/');

    let users = [];
    let header = '';
    let slug = '';
    let mode = '';

    if(parts[1] == 'members') {
      this.setState({loading: true});
      let response = await Server.public.getCommunityMembers();
      this.setState({loading: false});

      if(!response.success) {
        this.setState({error: response.message});
        return;
      }

      for(let i = 0; i < response.members.length; i++) 
        Server.public.addProfileToCache(response.members[i]);
      
      users = response.members;
      mode = 'members';
    }
    else {
      slug = parts[2];
      mode = parts[3];
  
      this.setState({loading: true});
      let response = await Server.public.loadProfileFromSlug(slug);
      this.setState({loading: false});

      if(!response.success) {
        this.setState({error: response.message});
        return;
      }

      let profile = response.profile;

      if(profile.id != Server.user.getId() && !Server.user.isFriend(profile.id)) {
        this.setState({error: 'You can only view followers of your friends.'});
        return;
      }

      let userIds = (mode == 'following') ? profile.following : profile.followers;

      await Server.public.loadProfiles(userIds);

      for(let i = 0 ; i < userIds.length; i++) 
        users.push(Server.public.getProfile(userIds[i]));

      if(mode == 'following')
        header = profile.name + ' Follows';
      else if(mode == 'followers')
        header = 'Following ' + profile.name;
    }


    this.setState({users, slug, mode, header})
  }

  onInvite() {
    if(Server.account.isLoggedIn()) {
      sessionStorage.setItem('InviteMember', this.state.search);
      this.setState({navigate: '/invites'});
    }
    else
      this.setState({alert: 'Please login to invite new members to this community.'})
  }

  onSearch() {
    this.setState({alert: 'Coming soon!'})
  }

  renderUsers() {
    if(!Server.account.isLoggedIn())
      return (
        <div className="site-page-panel">
          Please login to view the members of this community.
        </div>
      )

    let divs = [];
    for(let i = 0; i < this.state.users.length; i++) {
      let user = this.state.users[i];
      let activity = user.activity ? new Date(user.activity) : null;

      divs.push(
        <NavLink key={i} to={'/profile/' + user.slug} style={{textDecoration: 'none'}}>
          <div className="site-page-row">

            <Portrait user={user.id} />

            <div className="site-page-column" style={{rowGap: '3px'}}>
              <div className="site-page-title-text">{user.name}</div>
              {activity && 
                <div className="site-page-subtext">
                  Last login {activity.toLocaleString(undefined, {month: "short", day: "numeric", hour: "numeric", minute: "numeric"})}
                </div>
              }
            </div>
          </div>
        </NavLink>
      )
    }

    return (
      <div className="site-page-panel" style={{padding: '10px'}}>
        {divs.length == 0 ? 'There are no users in this list.' : divs}
      </div>
    )
  }

  render() {
    if(this.state.navigate != '')
      return (<Navigate to={this.state.navigate} />);
      
    return (
      <div className="site-page">
        <PageEnvelope width="500px">
          <div className="site-page-column">
            {this.state.loading &&
              <div className="site-page-panel">Loading...</div>
            }
            {!this.state.loading && this.state.error != '' &&
              <div className="site-page-panel">{this.state.error}</div>
            }
            {!this.state.loading && this.state.error == '' && 
              <div className="site-page-column">
                {this.state.header != '' &&
                  <PageHeader text={this.state.header} navigate={`/profile/${this.state.slug}`} />
                }
                {this.state.mode == 'members' && 
                  <div className="site-page-panel">
                    <div className="site-page-row">
                      <input 
                        style={{width: '100%'}} 
                        value={this.state.search}
                        onChange={(e) => this.setState({search: e.target.value})}
                        placeholder="Search users..."
                      />
                      <button onClick={()=>this.onSearch()} className="site-page-icon-button"><BsSearch/></button>
                      <div>&nbsp;</div>
                      <button onClick={()=>this.onInvite()}>Invite</button>
                    </div>
                  </div>
                }
                {this.renderUsers()}
              </div>
            }
          </div>
        </PageEnvelope>
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
      </div>
    )
  }
}

export default UsersPage;